// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TaParametersFromJSON(json) {
    return {
        'bow': !exists(json, 'bow') ? undefined : json['bow'],
        'lifetime': !exists(json, 'lifetime') ? undefined : json['lifetime'],
        'minDistributionRate': !exists(json, 'minDistributionRate') ? undefined : json['minDistributionRate'],
        'growthRate': !exists(json, 'growthRate') ? undefined : json['growthRate'],
        'terminal': !exists(json, 'terminal') ? undefined : json['terminal'],
        'contributionRates': !exists(json, 'contributionRates') ? undefined : json['contributionRates'],
    };
}
export function TaParametersToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'bow': value.bow,
        'lifetime': value.lifetime,
        'minDistributionRate': value.minDistributionRate,
        'growthRate': value.growthRate,
        'terminal': value.terminal,
        'contributionRates': value.contributionRates,
    };
}
